import { Currency } from '@snowit/icetypes';

import validators from './validators';

export interface ToMoneyProps {
  decimals?: number;
  int?: boolean;
  invert?: boolean;
  currency?: Currency | null;
  symbol?: boolean;
  isDelta?: boolean;
  locale?: string;
}

const LOCALE_SYMBOLS: Record<string, [string, string]> = {
  // [decimals, thousands]
  en: ['.', ','],
  default: [',', '.'],
};

export const round = (input: number, step = 1.0): number => {
  const inv = 1.0 / step;
  return Math.round(input * inv) / inv;
  // return Math.ceil(input * inv) / inv;
};

export const dotify = (input: string, locale: string): string => {
  const symbols = LOCALE_SYMBOLS[locale] || LOCALE_SYMBOLS.default;
  // thousands separator / decimals separator
  const [dsep, tsep] = symbols;
  const [int, decimals] = input.split('.');
  const integers = int.replace(/\B(?=(\d{3})+(?!\d))/g, tsep);
  return [integers, decimals].filter(Boolean).join(dsep);
};

const getCurrencySymbol = (input?: Currency | null, symbol = true) => {
  if (!symbol) return '';
  switch (input) {
    case Currency.Chf:
      return '₣';
    case 'USD' as Currency:
      return '$';
    case Currency.Eur:
    default:
      return '€';
  }
};

const toMoney = (input?: number, options: ToMoneyProps = {}): string => {
  if ((input !== 0 && !input) || !validators.isNumber(input)) return '';
  const {
    decimals = 2,
    int = false,
    invert = true,
    currency = Currency.Eur,
    symbol = true,
    isDelta = false,
    locale = 'it',
  } = options;
  const amount = round(input, 0.001);
  const write = (n: number | string) => {
    const value = dotify(String(n), locale);
    if (invert) return `${value}${getCurrencySymbol(currency, symbol)}`;
    return `${getCurrencySymbol(currency, symbol)}${value}`;
  };
  // INTEGER (or int) force the price to show without decimals
  const INTEGER = int || decimals === 0;
  return [isDelta && amount > 0 && '+', write(INTEGER ? round(amount) : amount.toFixed(decimals))]
    .filter((s): s is string => Boolean(s))
    .join('');
};

toMoney.symbol = (input: Currency, hide_symbol?: boolean): string =>
  hide_symbol ? '' : getCurrencySymbol(input);

export default toMoney;
